import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class UserService {
    static getUser(item) {
        let api = `${API_BASE_URL}${API_PATHS.getUser}`;

        const params = new URLSearchParams();

        if (item?.page !== undefined) params.append("page", item.page);
        if (item?.limit !== undefined) params.append("limit", item.limit);

        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);
        if (item?.search) params.append("search", item.search);

        if (item?.gender) params.append("gender", item.gender);

        if (item?.isActive !== undefined) {
            params.append("isActive", item.isActive);
        }

        if (item?.profileVerified !== undefined) {
            params.append("profileVerified", item.profileVerified);
        }

        if (item?.aadhaarVerified !== undefined) {
            params.append("aadhaarVerified", item.aadhaarVerified);
        }

        if (item?.hasPhoto !== undefined) {
            params.append("hasPhoto", item.hasPhoto);
        }

        if (item?.subscription) {
            params.append("subscription", item.subscription);
        }

        if (item?.fromDate) {
            params.append("fromDate", item.fromDate);
        }

        if (item?.toDate) {
            params.append("toDate", item.toDate);
        }

        if (item?.minAge) {
            params.append("minAge", item.minAge);
        }

        if (item?.maxAge) {
            params.append("maxAge", item.maxAge);
        }

        if (item?.sort) {
            params.append("sort", item.sort);
        }

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }

    static getunverifiedUser(item) {
        let api = `${API_BASE_URL}${API_PATHS.getunverifiedUser}`;

        const params = new URLSearchParams();

        if (item?.page !== undefined) params.append("page", item.page);
        if (item?.limit !== undefined) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);
        if (item?.search) params.append("search", item.search);

        if (item?.isActive !== undefined) {
            params.append("isActive", item.isActive);
        }

        if (item?.profileVerified !== undefined) {
            params.append("profileVerified", item.profileVerified);
        }

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api);
    }



    static addUser(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addUser}`;
        return axiosInstance
            .post(api, data)

    }

    // user ApproveDocument
    static editApproveDocument(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.approveDocument}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteUser(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteUser}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


    static getActivity(item) {
        let api = `${API_BASE_URL}${API_PATHS.getActivity}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.fromDate) params.append("fromDate", item.fromDate);
        if (item?.toDate) params.append("toDate", item.toDate);
        if (item?.type) params.append("type", item.type);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api); // ✅ FIXED
    }

    static getPayment(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPayment}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getSubscription(item) {

        let api = `${API_BASE_URL}${API_PATHS.getSubscription}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.usertype) params.append("usertype", item.usertype);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getuserSubscription(item) {

        let api = `${API_BASE_URL}${API_PATHS.getuserSubscription}`;

        const params = new URLSearchParams();

        if (item?.id) params.append("userId", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }



    static getDashSummary(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashSummary}`;
        const params = new URLSearchParams();
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance.get(api, item);
    }


    static getDashSubscription(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashSubscription}`;
        const params = new URLSearchParams();
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance.get(api, item);
    }




    static getDashData(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashData}`;
        const params = new URLSearchParams();
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance.get(api, item);
    }




    static getDashRegistartion(item) {

        let api = `${API_BASE_URL}${API_PATHS.getDashRegistartion}`;
        const params = new URLSearchParams();
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }
        return axiosInstance.get(api, item);
    }



}

export default UserService;
